<section class="section">
  <mat-form-field appearance="standard">
    <mat-label>{{ prop?.property?.description }}</mat-label>
    <input [formControl]="searchControl" matInput type="text" placeholder="Поиск..." />
    <button mat-icon-button matSuffix (click)="clear()">
      <mat-icon>clear</mat-icon>
    </button>
  </mat-form-field>
  <!-- <mat-chip-list>
    <mat-chip *ngFor="let value of selectedValues" (removed)="toggle(value)">
      {{ value }}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
  </mat-chip-list> -->
  <div class="checkbox-container">
    <mat-checkbox
      [checked]="isChecked(value)"
      *ngFor="let value of filteredValues"
      color="primary"
      (change)="toggle(value)"
      >{{ value }}</mat-checkbox
    >
  </div>
</section>
